<template>
  <router-view />
  <b-login
    :locale="locale"
    :env="env"
    :mode="loginMode"
    :redirect-url="redirectUrl"
    platform="web"
  />
</template>

<script lang="ts" setup>
import { useStore } from 'vuex';
import { computed, useSSRContext, onMounted, reactive } from 'vue';
import { BLogin, useLoginProvider } from '@bilibili-intl/login';
import { getEnv } from '@/common/env';
import { useServerPrefetch } from '@/composables/use-server-prefetch';
import LangManager from './locales/lang-manager';
import { LANG } from './constants';


const store = useStore();

useServerPrefetch(async() => await store.dispatch('getUserInfo'), store.state.global.userInfo);

onMounted(() => {
  const lang = LangManager.get();
  const  useBstation = lang === LANG.id;
  store.commit('setLocale', lang);
  store.commit('setUseBstation', useBstation);
});

const locale = computed(() => store.state.global.sLocale);
const env = getEnv();

const { visible } = useLoginProvider();

const loginMode = reactive({
  google: 'redirect',
  facebook: 'popup',
  twitter: 'popup',
});
// const disabledLoginMethods = ['facebook'];

const redirectUrl = computed (() => {
  if(import.meta.env.SSR){
    const ssrContext = useSSRContext();
    return ssrContext?.url;
  }
  return window.location.href;
});
</script>

<style scoped lang="less">

</style>
